import Home from "@/views/Home";
import auth from "../middleware/auth_middleware";
import profile from "../middleware/profiles_middleware"

export default [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      middleware: [auth]
    }
  },
  {
    path: "/profiles",
    name: "Profiles",
    component: () => import(/* webpackChunkName: "profiles" */ "@/views/Profiles"),
    meta: {
      middleware: [auth]
    }
  },
  {
    path: "/profile_home",
    name: "Profile_home",
    component: () =>  import(/* webpackChunkName: "profileHome" */ "@/views/ProfileHome"),
    meta: {
      middleware: [auth, profile],
    }
  },
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: () => import(/* webpackChunkName: "Subscribe" */ "@/views/payments/Subscribe"),
    meta: {
      middleware: [auth]
    }
  },
  {
    path: '/subscribed',
    name: 'SubscribeBtn',
    component: () => import(/* webpackChunkName: "SubscribeBtn" */ "@/views/payments/SubscribeBtn"),
    meta: {
      middleware: [auth]
    }
  },
  {
    path: "/personal",
    name: "Personal",
    component: () => import(/* webpackChunkName: "Personal" */ "@/views/Personal"),
    meta: {
      middleware: [auth]
    }
  },
  {
    path: "/gp",
    name: "GP",
    component: () => import(/* webpackChunkName: "Gp" */ "@/views/Gp"),
    meta: {
      middleware: [auth]
    }
  },
  {
    path: "/ice_contacts",
    name: "IceContacts",
    component: () => import(/* webpackChunkName: "Emergency Contacts" */ "@/views/EmergencyContacts"),
    meta: {
      middleware: [auth]
    }
  },
  {
    path: "/medications",
    name: "Medications",
    component: () => import(/* webpackChunkName: "Conditions" */ "@/views/Medications"),
    meta: {
      middleware: [auth]
    }
  },
  {
    path: "/conditions",
    name: "Conditions",
    component: () => import(/* webpackChunkName: "Conditions" */ "@/views/Conditions"),
    meta: {
      middleware: [auth]
    }
  },
  {
    path: "/vaccinations",
    name: "Vaccinations",
    component: () => import(/* webpackChunkName: "Vaccinations" */ "@/views/Vaccinations"),
    meta: {
      middleware: [auth]
    }
  },
  {
    path: "/allergies",
    name: "Allergies",
    component: () => import(/* webpackChunkName: "Allergies" */ "@/views/Allergies"),
    meta: {
      middleware: [auth]
    }
  },
  {
    path: "/devices",
    name: "Devices",
    component: () => import(/* webpackChunkName: "Devices" */ "@/views/Devices"),
    meta: {
      middleware: [auth]
    }
  },
  {
    path: "/files",
    name: "Files",
    component: () => import(/* webpackChunkName: "Files" */ "@/views/Files"),
    meta: {
      middleware: [auth]
    }
  },
  {
    path: '/qrcode',
    name: 'Qrcode',
    component: () => import(/* webpackChunkName: "Qrcode" */ "@/views/QrCode"),
    meta: {
      middleware: [auth]
    }
  }

];